import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';

import HourBlock from './HourBlock';

import './TimeGrid.css';

export const MINUTES_IN_BLOCK = 15;

export default class TimeGrid extends Component {
    static propTypes = {
        newStart: PropTypes.object,
        newEnd: PropTypes.object,
        roundedStart: PropTypes.object.isRequired,
        roundedEnd: PropTypes.object.isRequired,
        roundedMinStart: PropTypes.object.isRequired,
        roundedMaxEnd: PropTypes.object.isRequired,
        canEditStart: PropTypes.bool.isRequired,
        canEditEnd: PropTypes.bool.isRequired,
        minStartDate: PropTypes.object.isRequired,
        maxEndDate: PropTypes.object.isRequired,
        onStartChanged: PropTypes.func.isRequired,
        onEndChanged: PropTypes.func.isRequired,
        focusTime: PropTypes.object,
        startTimeUnavailabilityReasons: PropTypes.array.isRequired,
        endTimeUnavailabilityReasons: PropTypes.array.isRequired,
        onUnavailableTimeSlotClicked: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props);

        this.state = {
            editingStart: false,
            editingEnd: false,
        };

        this.onTimeSelected = this.onTimeSelected.bind(this);
        this.onEditingStart = this.onEditingStart.bind(this);
        this.onEditingEnd = this.onEditingEnd.bind(this);
        this.onScrollTo = this.onScrollTo.bind(this);
    }

    onTimeSelected(newTime) {
        if (this.state.editingStart) {
            this.props.onStartChanged(newTime);
        } else if (this.state.editingEnd) {
            // We add 15 minutes here since for the end time we are concerned with the end time of the block
            this.props.onEndChanged(newTime.add(MINUTES_IN_BLOCK, `m`));
        }
    }

    onEditingStart() {
        if (!this.state.editingStart) {
            this.setState({
                editingStart: true,
                editingEnd: false,
            });
        } else {
            this.setState({ editingStart: false });
        }
    }

    onEditingEnd() {
        if (!this.state.editingEnd) {
            this.setState({
                editingStart: false,
                editingEnd: true,
            });
        } else {
            this.setState({ editingEnd: false });
        }
    }

    onScrollTo(top) {
        const element = ReactDOM.findDOMNode(this);

        // Scroll this element so the top value is in the middle of the viewport
        element.scrollTop = (top + element.scrollTop) - (element.getBoundingClientRect().height / 2);
    }

    render() {
        const { minStartDate, maxEndDate } = this.props;

        const startBounds = moment(minStartDate).startOf(`h`).add(-1, `h`);
        const endBounds = moment(maxEndDate).endOf(`h`).add(1, `h`);

        const duration = moment.duration(endBounds.diff(startBounds));
        const hours = Math.ceil(duration.asHours());

        let hourBlocksJsx = [];
        for (let i = 0; i < hours; i++) {
            const hour = moment(startBounds).add(i, `h`);
            hourBlocksJsx.push(
                <HourBlock
                    key={i}
                    hour={hour}
                    minutesInBlock={MINUTES_IN_BLOCK}
                    newStart={this.props.newStart}
                    newEnd={this.props.newEnd}
                    roundedStart={this.props.roundedStart}
                    roundedEnd={this.props.roundedEnd}
                    roundedMinStart={this.props.roundedMinStart}
                    roundedMaxEnd={this.props.roundedMaxEnd}
                    canEditStart={this.props.canEditStart}
                    canEditEnd={this.props.canEditEnd}
                    editingStart={this.state.editingStart}
                    editingEnd={this.state.editingEnd}
                    onTimeSelected={this.onTimeSelected}
                    onEditingStart={this.onEditingStart}
                    onEditingEnd={this.onEditingEnd}
                    focusTime={this.props.focusTime}
                    onScrollTo={this.onScrollTo}
                    startTimeUnavailabilityReasons={this.props.startTimeUnavailabilityReasons}
                    endTimeUnavailabilityReasons={this.props.endTimeUnavailabilityReasons}
                    onUnavailableTimeSlotClicked={this.props.onUnavailableTimeSlotClicked}
                />
            );
        }

        return (
            <div className="time-grid invisible-scrollbar">
                {hourBlocksJsx}
                <div className="unavailable-time-info-icon unavailable-time-info-start-icon">
                    <i className="material-icons">&#xE88E;</i>
                </div>
                <div className="unavailable-time-info-icon unavailable-time-info-end-icon">
                    <i className="material-icons">&#xE88E;</i>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/Common/TimeSelector/TimeGrid.jsx